<section class="vh-100 main-bg">
  <div class="container py-5 h-100">
    <div class="row d-flex justify-content-center align-items-center h-100">
      <div class="col-12 col-md-8 col-lg-6 col-xl-5">
        <div
          class="shadow-2-strong glass-box">
          <div class="card-body px-5 text-center">
            <h3 class="mb-3" style="color: #fff;font-size: 32px;font-weight: 300;">
              Delete Account Request
            </h3>
            <form
              [formGroup]="deleteForm"
              (ngSubmit)="onSubmit()"
              style="
                width: 100%;
                padding: 20px;
                border: none;
                border-radius: 2px;
                font-size: 16px;
                font-weight: 400;
                margin-bottom: 10px;
              "
            >
              <div class="form-group text-white">
                <input
                  type="email"
                  id="email"
                  placeholder="Email"
                  class="form-control text-white"
                  formControlName="email"
                  name="email"
                  
                />
              </div>
              <span *ngIf="!this.validate_email" class="alert-message">
                Invalid Email address!, Provide a valid Email ID.
              </span>
              <span *ngIf="field_empty" class="alert-message">
                Email field cannot be empty.
              </span>
              <span *ngIf="delete_account_message" class="alert-message">
                No user details found.
              </span>
              <div>
                <button type="submit" style="width: 100%">
                  <span *ngIf="!submited">SUBMIT</span>
                  <span *ngIf="submited" class="spinner-border sr-only" role="status"></span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


